<div class="main-page">
  <ng-container *ngIf="!isLoading; else loadingTemplate">


    <div [ngClass]="isMobile ? 'mobile-header' : 'header'">
      <app-external-header
        style="z-index: 1000; position: relative; width: 100%"
        [isInboxPresent]="true"
        [isCompanyProfile]="false"
        [isProfile]="true"
        [showButtons]="false"
        [isMobile]="isMobile"
        [showProfilePicture]="true"
        [showConsultationCta]="true"
      ></app-external-header>
    </div>

    <div class="main-wrapper">
      <div class="content">
        <div class="main-layout">
          <div class="sidebar" *ngIf="jobOffers.length > 0">
            <app-search-bar
              [offers]="jobOffers"
              (searchResult)="applySearchFromBar($event)">
            </app-search-bar>

          </div>
        </div>


        <div class="job-offers">
          <a *ngFor="let offer of filteredOffers" [routerLink]="['/job-description', offer.id]">
            <app-job-offer-card [offer]="offer"></app-job-offer-card>
          </a>
        </div>


      </div>

      <div *ngIf="jobOffers.length === 0" class="main-layout no-offers-layout">
        <div class="no-offers-message">{{ 'jobs.no_jobs' | translate }}</div>
      </div>

      <div style="width: 100%;">
        <app-consultation-banner></app-consultation-banner>
      </div>
      <div class="footer-class">
        <div class="footer-container">
          <app-footer></app-footer>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<ng-template #loadingTemplate>
  <app-load-mask></app-load-mask>
</ng-template>
